import Vue from "vue";
import purchaseTransformer from "@/transformers/purchase/purchaseOrders";

export default ({ folio }) =>
  Vue.$http
    .get(`purchase/order_detail/${folio}/`)
    .then(({ data }) => purchaseTransformer.fetch(data));



// WEBPACK FOOTER //
// ./src/services/purchase/fetchPurchaseOrder.js